import { render, staticRenderFns } from "./WorkExperienceForm.vue?vue&type=template&id=c563d914&scoped=true"
import script from "./WorkExperienceForm.vue?vue&type=script&lang=js"
export * from "./WorkExperienceForm.vue?vue&type=script&lang=js"
import style0 from "./WorkExperienceForm.vue?vue&type=style&index=0&id=c563d914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c563d914",
  null
  
)

export default component.exports